import { jsx as t, Fragment as f } from "react/jsx-runtime";
import { c as u, b as p, e as b } from "../../vendor-Blw3V4C-.js";
import { forwardRef as v } from "react";
import { stupidInvertClasses as B } from "../../utils/index.js";
import { getButtonStyles as g } from "../BaseButton/index.js";
import { BaseIcon as i } from "../BaseIcon/index.js";
import { isIconName as a } from "../BaseIcon/typeGuards.js";
import { DotProgress as y } from "../DotProgress/index.js";
import { withTooltip as $ } from "../Tooltip/withTooltip.js";
import '../../assets/index8.css';const x = "_iconButton_1cuaz_1", I = {
  iconButton: x
}, F = $(
  v(
    ({
      isPendingAriaLabel: m = "Loading",
      size: r = "md",
      icon: e,
      href: n,
      __inverted: l,
      variant: d = "secondary",
      ...o
    }, s) => {
      const c = u(
        g({
          variant: d,
          size: r,
          ...o
        }),
        I.iconButton,
        l ? B() : void 0
      );
      return typeof n == "string" ? /* @__PURE__ */ t(
        p,
        {
          ...o,
          href: n,
          className: c,
          slot: null,
          style: void 0,
          ref: s,
          children: a(e) && /* @__PURE__ */ t(i, { icon: e, size: r })
        }
      ) : /* @__PURE__ */ t(
        b,
        {
          ...o,
          type: "button",
          "data-active": o.isActive ? "true" : void 0,
          className: c,
          slot: null,
          style: void 0,
          ref: s,
          children: o.isPending ? /* @__PURE__ */ t(y, { "aria-label": m, size: r }) : /* @__PURE__ */ t(f, { children: a(e) && /* @__PURE__ */ t(i, { icon: e, size: r }) })
        }
      );
    }
  )
);
export {
  F as IconButton
};
//# sourceMappingURL=index.js.map
